export default __webpack_public_path__ + "static/media/Japan_Particle_0009_Yamato_Firework1.7afd6c84.png";